/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TailoredDefragSummaryCardQueryVariables = {
    orgId: string;
};
export type TailoredDefragSummaryCardQueryResponse = {
    readonly org: {
        readonly tailoredDefragCardSummary?: ({
            readonly __typename: "TailoredDefragCardSummary";
            readonly yourEventMoves: ReadonlyArray<{
                readonly event: {
                    readonly title: string | null;
                };
            }>;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        }) | null | undefined;
        readonly " $fragmentRefs": FragmentRefs<"TailoredDefragSummaryCard_org">;
    } | null;
};
export type TailoredDefragSummaryCardQuery = {
    readonly response: TailoredDefragSummaryCardQueryResponse;
    readonly variables: TailoredDefragSummaryCardQueryVariables;
};



/*
query TailoredDefragSummaryCardQuery(
  $orgId: ID!
) {
  org: node(id: $orgId) {
    __typename
    ... on Org {
      ...TailoredDefragSummaryCard_org
      tailoredDefragCardSummary {
        __typename
        ... on TailoredDefragCardSummary {
          yourEventMoves {
            event {
              title
            }
          }
        }
      }
    }
    id
  }
}

fragment AvatarPerson_org on Org {
  id
}

fragment AvatarPerson_person on Person {
  __typename
  id
  emails
  primaryEmail
  isYou
  userId
  isUser
  profile {
    givenName
    familyName
    externalImageUrl
  }
}

fragment AvatarRow_org on Org {
  ...AvatarPerson_org
}

fragment AvatarRow_personList on PersonList {
  list {
    ...AvatarPerson_person
    primaryEmail
    id
  }
}

fragment TailoredDefragSummaryAttendeeStats_org on Org {
  ...TailoredDefragSummaryAttendees_org
}

fragment TailoredDefragSummaryAttendeeStats_tailoredDefragCardSummary on TailoredDefragCardSummary {
  defragTime
  impactedOtherCalendarIds
  valueStrings
  yourEventMoves {
    newStartTime {
      dateOrDateTime
    }
    originalStartTime {
      dateOrDateTime
    }
    moveReasons
    event {
      title
      calendarIds
    }
  }
  calendarValueStrings {
    calendarId
    valueStrings
  }
  persons {
    __typename
    ... on PersonList {
      ...TailoredDefragSummaryAttendees_personList
      list {
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        id
      }
    }
  }
}

fragment TailoredDefragSummaryAttendees_org on Org {
  ...AvatarRow_org
}

fragment TailoredDefragSummaryAttendees_personList on PersonList {
  ...AvatarRow_personList
  list {
    primaryEmail
    profile {
      givenName
      familyName
    }
    id
  }
}

fragment TailoredDefragSummaryCard_org on Org {
  ...TailoredDefragSummaryAttendeeStats_org
  id
  tailoredDefragCardSummary {
    __typename
    ... on TailoredDefragCardSummary {
      ...TailoredDefragSummaryAttendeeStats_tailoredDefragCardSummary
      defragTime
      impactedOtherCalendarIds
      valueStrings
      yourEventMoves {
        ...TailoredDefragSummaryEventsMovedList_eventsMoved
        newStartTime {
          dateOrDateTime
        }
        originalStartTime {
          dateOrDateTime
        }
        moveReasons
        addedRooms
        removedRooms
        event {
          title
          eventKey {
            externalEventId
            id
          }
        }
      }
      persons {
        __typename
        ... on PersonList {
          list {
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            id
          }
        }
      }
      rooms {
        __typename
        ... on RoomList {
          ...TailoredDefragSummaryEventsMovedList_rooms
          list {
            roomId
            name
            id
          }
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment TailoredDefragSummaryEventMoved_eventMoved on DefragExplainedMove {
  originalStartTime {
    millis
  }
  newStartTime {
    millis
  }
  moveReasons
  addedRooms
  removedRooms
  event {
    title
    startTime {
      millis
    }
    endTime {
      millis
    }
    eventKey {
      externalEventId
      id
    }
  }
}

fragment TailoredDefragSummaryEventMoved_rooms on RoomList {
  list {
    roomId
    name
    id
  }
}

fragment TailoredDefragSummaryEventsMovedList_eventsMoved on DefragExplainedMove {
  ...TailoredDefragSummaryEventMoved_eventMoved
}

fragment TailoredDefragSummaryEventsMovedList_rooms on RoomList {
  ...TailoredDefragSummaryEventMoved_rooms
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "orgId"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgId"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "valueStrings",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "millis",
        "storageKey": null
    } as any, v7 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        } as any,
        (v6 /*: any*/)
    ], v8 = [
        (v6 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "TailoredDefragSummaryCardQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "tailoredDefragCardSummary",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DefragExplainedMove",
                                                    "kind": "LinkedField",
                                                    "name": "yourEventMoves",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Event",
                                                            "kind": "LinkedField",
                                                            "name": "event",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "TailoredDefragCardSummary",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "TailoredDefragSummaryCard_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "TailoredDefragSummaryCardQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v1 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        (v4 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "tailoredDefragCardSummary",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "defragTime",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "impactedOtherCalendarIds",
                                                    "storageKey": null
                                                },
                                                (v5 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DefragExplainedMove",
                                                    "kind": "LinkedField",
                                                    "name": "yourEventMoves",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventTime",
                                                            "kind": "LinkedField",
                                                            "name": "newStartTime",
                                                            "plural": false,
                                                            "selections": (v7 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "EventTime",
                                                            "kind": "LinkedField",
                                                            "name": "originalStartTime",
                                                            "plural": false,
                                                            "selections": (v7 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "moveReasons",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Event",
                                                            "kind": "LinkedField",
                                                            "name": "event",
                                                            "plural": false,
                                                            "selections": [
                                                                (v3 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "calendarIds",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "EventTime",
                                                                    "kind": "LinkedField",
                                                                    "name": "startTime",
                                                                    "plural": false,
                                                                    "selections": (v8 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "EventTime",
                                                                    "kind": "LinkedField",
                                                                    "name": "endTime",
                                                                    "plural": false,
                                                                    "selections": (v8 /*: any*/),
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "EventKey",
                                                                    "kind": "LinkedField",
                                                                    "name": "eventKey",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "externalEventId",
                                                                            "storageKey": null
                                                                        },
                                                                        (v4 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "addedRooms",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "removedRooms",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TailoredDefragCalendarValueStrings",
                                                    "kind": "LinkedField",
                                                    "name": "calendarValueStrings",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "calendarId",
                                                            "storageKey": null
                                                        },
                                                        (v5 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "persons",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Person",
                                                                    "kind": "LinkedField",
                                                                    "name": "list",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        (v4 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "emails",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "primaryEmail",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "isYou",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "userId",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "isUser",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "UserProfile",
                                                                            "kind": "LinkedField",
                                                                            "name": "profile",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "givenName",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "familyName",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "externalImageUrl",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "type": "PersonList",
                                                            "abstractKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "rooms",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Room",
                                                                    "kind": "LinkedField",
                                                                    "name": "list",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "roomId",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "name",
                                                                            "storageKey": null
                                                                        },
                                                                        (v4 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "type": "RoomList",
                                                            "abstractKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "TailoredDefragCardSummary",
                                            "abstractKey": null
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "message",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "GraphEntityError",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "b7db25f9d3a48f471da23aa1bbbab4f0",
            "id": null,
            "metadata": {},
            "name": "TailoredDefragSummaryCardQuery",
            "operationKind": "query",
            "text": "query TailoredDefragSummaryCardQuery(\n  $orgId: ID!\n) {\n  org: node(id: $orgId) {\n    __typename\n    ... on Org {\n      ...TailoredDefragSummaryCard_org\n      tailoredDefragCardSummary {\n        __typename\n        ... on TailoredDefragCardSummary {\n          yourEventMoves {\n            event {\n              title\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AvatarPerson_org on Org {\n  id\n}\n\nfragment AvatarPerson_person on Person {\n  __typename\n  id\n  emails\n  primaryEmail\n  isYou\n  userId\n  isUser\n  profile {\n    givenName\n    familyName\n    externalImageUrl\n  }\n}\n\nfragment AvatarRow_org on Org {\n  ...AvatarPerson_org\n}\n\nfragment AvatarRow_personList on PersonList {\n  list {\n    ...AvatarPerson_person\n    primaryEmail\n    id\n  }\n}\n\nfragment TailoredDefragSummaryAttendeeStats_org on Org {\n  ...TailoredDefragSummaryAttendees_org\n}\n\nfragment TailoredDefragSummaryAttendeeStats_tailoredDefragCardSummary on TailoredDefragCardSummary {\n  defragTime\n  impactedOtherCalendarIds\n  valueStrings\n  yourEventMoves {\n    newStartTime {\n      dateOrDateTime\n    }\n    originalStartTime {\n      dateOrDateTime\n    }\n    moveReasons\n    event {\n      title\n      calendarIds\n    }\n  }\n  calendarValueStrings {\n    calendarId\n    valueStrings\n  }\n  persons {\n    __typename\n    ... on PersonList {\n      ...TailoredDefragSummaryAttendees_personList\n      list {\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment TailoredDefragSummaryAttendees_org on Org {\n  ...AvatarRow_org\n}\n\nfragment TailoredDefragSummaryAttendees_personList on PersonList {\n  ...AvatarRow_personList\n  list {\n    primaryEmail\n    profile {\n      givenName\n      familyName\n    }\n    id\n  }\n}\n\nfragment TailoredDefragSummaryCard_org on Org {\n  ...TailoredDefragSummaryAttendeeStats_org\n  id\n  tailoredDefragCardSummary {\n    __typename\n    ... on TailoredDefragCardSummary {\n      ...TailoredDefragSummaryAttendeeStats_tailoredDefragCardSummary\n      defragTime\n      impactedOtherCalendarIds\n      valueStrings\n      yourEventMoves {\n        ...TailoredDefragSummaryEventsMovedList_eventsMoved\n        newStartTime {\n          dateOrDateTime\n        }\n        originalStartTime {\n          dateOrDateTime\n        }\n        moveReasons\n        addedRooms\n        removedRooms\n        event {\n          title\n          eventKey {\n            externalEventId\n            id\n          }\n        }\n      }\n      persons {\n        __typename\n        ... on PersonList {\n          list {\n            primaryEmail\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n            id\n          }\n        }\n      }\n      rooms {\n        __typename\n        ... on RoomList {\n          ...TailoredDefragSummaryEventsMovedList_rooms\n          list {\n            roomId\n            name\n            id\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment TailoredDefragSummaryEventMoved_eventMoved on DefragExplainedMove {\n  originalStartTime {\n    millis\n  }\n  newStartTime {\n    millis\n  }\n  moveReasons\n  addedRooms\n  removedRooms\n  event {\n    title\n    startTime {\n      millis\n    }\n    endTime {\n      millis\n    }\n    eventKey {\n      externalEventId\n      id\n    }\n  }\n}\n\nfragment TailoredDefragSummaryEventMoved_rooms on RoomList {\n  list {\n    roomId\n    name\n    id\n  }\n}\n\nfragment TailoredDefragSummaryEventsMovedList_eventsMoved on DefragExplainedMove {\n  ...TailoredDefragSummaryEventMoved_eventMoved\n}\n\nfragment TailoredDefragSummaryEventsMovedList_rooms on RoomList {\n  ...TailoredDefragSummaryEventMoved_rooms\n}\n"
        }
    } as any;
})();
(node as any).hash = 'ca787c85ab321c27db18550b012e40f7';
export default node;
